import { apiDelete, apiGet, apiPost } from './client';
import type {
  CommentView,
  CreatePostInput,
  FeedPage,
  LikeResult,
  PostDetailView,
  PostType,
  PostView,
  ReportReason,
  SocialUser,
} from './community.types';
import { isSocialMockEnabled } from '../featureFlags';
import { mockCommunityApi } from '../mock/social';

const realCommunityApi = {
  getMe: () => apiGet<SocialUser>('/community/me'),
  /** `cursor` = nextCursor của trang trước. Không truyền `type` = mọi loại bài. */
  getFeed: (type?: PostType, cursor?: string | null) => {
    const query = [type && `type=${type}`, cursor && `cursor=${encodeURIComponent(cursor)}`].filter(Boolean).join('&');
    return apiGet<FeedPage>(`/community/posts${query ? `?${query}` : ''}`);
  },
  getPost: (postId: string) => apiGet<PostDetailView>(`/community/posts/${postId}`),
  createPost: (input: CreatePostInput) => apiPost<PostView>('/community/posts', input),
  deletePost: (postId: string) => apiDelete<{ deleted: true }>(`/community/posts/${postId}`),
  likePost: (postId: string) => apiPost<LikeResult>(`/community/posts/${postId}/like`),
  unlikePost: (postId: string) => apiDelete<LikeResult>(`/community/posts/${postId}/like`),
  addComment: (postId: string, body: string) => apiPost<CommentView>(`/community/posts/${postId}/comments`, { body }),
  deleteComment: (commentId: string) => apiDelete<{ deleted: true }>(`/community/comments/${commentId}`),
  likeComment: (commentId: string) => apiPost<LikeResult>(`/community/comments/${commentId}/like`),
  unlikeComment: (commentId: string) => apiDelete<LikeResult>(`/community/comments/${commentId}/like`),
  /** Người đăng chọn câu trả lời đúng; gọi lại trên bình luận đang được chọn = bỏ chọn. */
  toggleBestComment: (commentId: string) => apiPost<{ isBest: boolean; solved: boolean }>(`/community/comments/${commentId}/best`),
  reportPost: (postId: string, reason: ReportReason) => apiPost<{ reported: true }>(`/community/posts/${postId}/report`, { reason }),
};

export const communityApi: typeof realCommunityApi = isSocialMockEnabled() ? mockCommunityApi : realCommunityApi;
